<div class="bg-danger py-5 text-white text-center">
  <h1>Catching Teams</h1>
</div>
<div class="bg-light py-2">
  <div class="container">
    <div class="d-flex justify-content-between">
      <div>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search teams..." aria-label="Recipient's username">
          <button class="btn btn-outline-dark" type="button"><i class="fas fa-search"></i></button>
        </div>
      </div>
      <button class="btn btn-outline-dark"><i class="fas fa-plus me-2"></i>Create Team</button>
    </div>
  </div>
</div>

<div class="container my-4">
  <div class="row row-cols-1 row-cols-md-3 g-4">
    <div class="col" *ngFor="let team of catcherService.teams$ | async">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">{{ team.name }}</h5>
          <p class="card-text">{{ team.id }}</p>
          <p class="card-text"><strong>{{team.contactName}}</strong>, {{team.otherMembers}}</p>
        </div>
        <div class="card-footer d-flex justify-content-between">
          <button class="btn btn-outline-primary"><i class="fas fa-key me-2" (click)="authService.resetPassword(team.id)"></i>Password Reset</button>
        </div>
      </div>
    </div>
  </div>
</div>
